import { useEffect, useState } from 'react';

// True below the Tailwind `md` breakpoint (smartphones) — drives card-vs-table layouts.
export default function useIsMobile(maxWidth = 767) {
  const query = `(max-width: ${maxWidth}px)`;
  const [mobile, setMobile] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = (e) => setMobile(e.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return mobile;
}
